import { ComponentStyle, Datetime, errorMessagesSection, faExclamationCircle, FormStyle,
         infoPlaceholderSection, React} from "@/imports-files/components/custom-datetime";
         import { useState } from 'react';

         import MomentUtils from '@date-io/moment';

         import {
           TimePicker,
           MuiPickersUtilsProvider,
         } from '@material-ui/pickers';

export function CustomTimePicker(props)
{
      return(

            <div className= {`CustomDatePicker`} >
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <TimePicker
                      autoOk
                      ampm            =    {false}
                      variant         =    "inline"
                      className       =   {  props.className }
                      inputProps      =   { props.inputProps }
                      onChange        =   { props.onChange }
                      ref             =   { props.reference }
                      selected        =   { props.selected }
                      value           =   { props.value ? props.value : null}
                      disabled        =   { props.inputProps?.disabled ? props.inputProps?.disabled : false }
                />

              </MuiPickersUtilsProvider>

              {
                props.inputProps.style != undefined ?  errorMessagesSection( props.name, FormStyle, props.formik)
                                                    :  infoPlaceholderSection( props.infoPlaceholder, FormStyle)
              }

            </div>

            )
}
